import React from "react";
import { ProgramContainer } from "../../entities/formTemplateDataType";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import { FR_SUFFIX } from "../../entities/Constants";
import Utils from "../../utilities/Utils";
import { DialogBase, State } from "./DialogBase";

interface Props {
    programContainer: ProgramContainer
    isEng: boolean;
    dialogVisible:boolean;
    callback;
}

export class DialogForHelpComponent extends DialogBase<Props,State>  {
    constructor(props: Props) {
        super(props);

       
    }

    generateContentString = () => {

        let htmlString = [];
        htmlString.push(
            <div  style={{width: "100%",paddingTop: "5px"}}>
                <div style={{ display:  "flex" , marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_HelpHeader_" + this.props.programContainer.id}>Help Header</label>
                    </div>
                    <div style={{ width: '60%'}}>   
                        {/* @ts-ignore */}
                        <Editor   style={{ height: 'auto' }}
                        id={"tbl_HelpHeader_" + this.props.programContainer.id}
                        value={this.props.isEng ? this.props.programContainer.HelpHeader: this.props.programContainer.HelpHeaderFRA} 
                        onTextChange={(e) => {
                            if (this.props.isEng){
                                if(Utils.willDefaultFR(this.props.programContainer.HelpHeader,this.props.programContainer.HelpHeaderFRA)){
                                    this.props.programContainer.HelpHeaderFRA= Utils.isNullOrEmpty(e.htmlValue)? '':e.htmlValue+ FR_SUFFIX;
                                }
                                this.props.programContainer.HelpHeader= e.htmlValue;
                            }else{
                                this.props.programContainer.HelpHeaderFRA = e.htmlValue;
                            }
                            this.props.callback();
                        }}></Editor>
                    </div>
                </div>

                <div style={{ display:  "flex" , marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_HelpContent_" + this.props.programContainer.id}>Help Content</label>
                    </div>
                    <div style={{ width: '60%'}}>
                        {/* @ts-ignore */}
                        <Editor   style={{ height: 'auto' }}
                        id={"tbl_HelpContent_" + this.props.programContainer.id}
                        value={this.props.isEng ? this.props.programContainer.HelpRichText: this.props.programContainer.HelpRichTextFRA} 
                        onTextChange={(e) => {
                            if (this.props.isEng){
                                if(Utils.willDefaultFR(this.props.programContainer.HelpRichText,this.props.programContainer.HelpRichTextFRA)){
                                    this.props.programContainer.HelpRichTextFRA= Utils.isNullOrEmpty(e.htmlValue)? '':e.htmlValue+ FR_SUFFIX;
                                }
                                this.props.programContainer.HelpRichText= e.htmlValue;
                            }else{
                                this.props.programContainer.HelpRichTextFRA = e.htmlValue;
                            }
                            this.props.callback();
                        }}></Editor>
                    </div>
                </div>

                <div style={{ display:  "flex" , marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_HelpFooter_" + this.props.programContainer.id}>Help Footer</label>
                    </div>
                    <div style={{ width: '60%'}}>
                        {/* @ts-ignore */}
                        <Editor   style={{ height: 'auto' }}
                        id={"tbl_HelpFooter_" + this.props.programContainer.id}
                        value={this.props.isEng ? this.props.programContainer.HelpFooter: this.props.programContainer.HelpFooterFRA} 
                        onTextChange={(e) => {
                            if (this.props.isEng){
                                if(Utils.willDefaultFR(this.props.programContainer.HelpFooter,this.props.programContainer.HelpFooterFRA)){
                                    this.props.programContainer.HelpFooterFRA= Utils.isNullOrEmpty(e.htmlValue)? '':e.htmlValue+ FR_SUFFIX;
                                }
                                this.props.programContainer.HelpFooter= e.htmlValue;
                            }else{
                                this.props.programContainer.HelpFooterFRA = e.htmlValue;
                            }
                            this.props.callback();
                        }}></Editor>
                    </div>
                </div>

            </div>);

        return htmlString;
    };
  
    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    generateHtmlString = () => {
        let html = [];
        html.push(<>
        {/* @ts-ignore */}
        <Dialog header={this.props.isEng ? "Help content setting": "[FR] Help content setting"} footer={this.renderFooter()}
            visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
            {this.generateContentString()}
        </Dialog></>);
        return html;
    }

  
    render() {
    
        return (
            <div>
                {this.generateHtmlString()}
            </div>
        );
    }
}
